module.exports = __webpack_public_path__ + "img/IMG_20191126_235630.fd3bf000.jpg";